import { SVGProps, Ref, forwardRef } from 'react';

export const BulletFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M6 12c0-3 1.5-6 6-6s6 3 6 6-1.5 6-6 6-6-3-6-6" fill="currentColor" />
    </svg>
));
BulletFilledSize24Glyph.displayName = 'BulletFilledSize24Glyph';
